module.exports = __webpack_public_path__ + "img/Sunball_tennis_court-Sports_Poster_HD_Wallpaper_2560x1600.e2f91638.jpg";